import { MatrixServices } from './../../../../services/image/matrix.services'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { SharedServices } from '../../../../services/shared.services'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { onsNotification } from 'ngx-onsenui'
import * as moment from 'moment'
import { StateServices } from '../../../../services/state.services'
import Constants from '../../../../commons/Constants'
import { DatepickerHelper } from '../../../../../helper/datepicker.helper'
import { mongoObjectId } from '@helpers/common'

@Component({
    selector: 'app-select-new',
    templateUrl: './new-client.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './new-client.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class NewClientComponent implements OnInit, OnDestroy {
    formNewClient: FormGroup
    listClinic: any
    listDoctor: any
    listCordinator: any
    arrayGender = Constants.ARRAY_GENDER
    arrayUseTreatment = Constants.ARRAY_USE_TREATMENT
    arrayDevice = Constants.ACCELEDENT_DEVICES
    arrayPublication = Constants.ARRAY_PUBLICATION_APPROVED
    arrayAligner = Constants.ARRAY_ALIGNER_MAIL
    urls: any[] = []
    displayRemoveUrl = true
    list: any
    doctorName: string = ''
    cordinatorName: string = ''
    errorTextEmail1: string = 'Invalid mail format'
    errorTextEmail2: string = 'Invalid mail format'
    validEmail1 = false
    validEmail2 = false
    statusCheck
    clinicSelected = ''
    doctorSelected = ''
    cordinatorSelected = ''
    genderSelected
    useTreatmentSelected
    accelationSelected
    alignerMailSelected
    publicationSelected
    listUrl: any[] = []
    dateBirthday: any
    optionsBirthday: any = {
        viewMode: 'years',
        defaultDate: '1990-01-01',
        ...DatepickerHelper.BASE_NONE_TODAY_OPTIONS,
    }
    dateStart: any
    dateLast: any
    optionsStartDate: any = { viewMode: 'days', ...DatepickerHelper.BASE_OPTIONS }
    optionsLastDate: any = { viewMode: 'days', ...DatepickerHelper.BASE_OPTIONS }
    showDateBirthday: string = 'Click to Select'
    showDateStart: string = 'Click to Select'
    showDateLast: string = 'Click to Select'
    showAge: number = 0
    timestampBirthday: number
    timestampStart: number
    timestampLast: number
    en = {}
    showEN = true

    listOption2General: any[] = []
    jsonDataSave: any = {}
    listOptionFooter: any[] = []
    jsonChangeDataSave: any = {}

    saveData
    enableBehavior = 'false'
    jsonDateToday: any = {}
    header = 'header'
    footer = 'footer'
    isValidate = true
    isFamilyName = true
    isFirstName = true
    isCheck = false

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private stateServices: StateServices, private _sharedService: SharedServices, private formBuilder: FormBuilder, private matrixServices: MatrixServices) {
        _sharedService.changeEmittedSource$.subscribe(
            res => {
                this.enableBehavior = this.stateServices.returnEnableBehavior()
                const emitLoading = {}
                emitLoading['first'] = false
                this.stateServices.emitChangeFirstLoading(emitLoading)
                this.list = res
                if (Array.isArray(res)) {
                    let resultTest3 = res.find(staff => staff.role === 'doctor')
                    let resultTest4 = res.find(staff => staff.role === 'cordinator')
                    if (resultTest3) {
                        let resultTest = this.listDoctor.find(staff => staff._id === resultTest3.id)
                        this.doctorName = (resultTest.firstName || '') + ' ' + (resultTest.familyName || '')
                        if (resultTest) {
                            this.doctorSelected = resultTest._id
                            this._sharedService.emitChange(['activeAlertNewClient', 'client'])
                        } else {
                            this.doctorSelected = null
                        }
                    }
                    if (resultTest4) {
                        let resultTest2 = this.listCordinator.find(staff => staff._id === resultTest4.id)
                        this.cordinatorName = (resultTest2.firstName || '') + ' ' + (resultTest2.familyName || '')
                        if (resultTest2) {
                            this.cordinatorSelected = resultTest2._id
                            this._sharedService.emitChange(['activeAlertNewClient', 'client'])
                        } else {
                            this.cordinatorSelected = null
                        }
                    }
                }

            })
    }

    ngOnInit() {
        this.stateServices.emitChangeHash(null)
        this.matrixServices.resetMatrix()
        this.stateServices.emitChangeViewAligner('renderData')
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        $('ons-page').find('.ng-scrollbar').addClass('-vertical')
        this.stateServices.emitChangeArrImageHash(null)
        this.setNoneAcceledent()
        this.selectDefaultTreatementUse()
        this.mainClient()

        this.formNewClient = this.formBuilder.group({
            clientNumber: '',
            familyName: ['', [Validators.required]],
            firstName: ['', [Validators.required]],
            familyNameKana: '',
            firstNameKana: '',
            birthDay: '',
            phoneNumber1: '',
            phoneNumber2: '',
            address1: '',
            address2: '',
            email1: ['', [Validators.email]],
            email2: ['', [Validators.email]],
            startDate: '',
            lastDate: '',
            presentationName: '',
            case: '',
            urls: this.formBuilder.array([this.createItemUrl()]),
        })
        this.urls = this.formNewClient.get('urls')['controls']
        this.functionSaveData()
    }

    ngOnDestroy() {
        if(this.saveData)
            this.saveData.unsubscribe()
    }

    functionSaveData() {
        this.saveData = this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success && success[0] === 'saveNewClient' && success[1] == 'client') {
                    this.submitFormNewClient()
                }
            },
        )
    }

    functionEmitJsonSave(jsonSave: any) {
        this.jsonChangeDataSave = jsonSave
        const listKeys = Object.keys(jsonSave)
        const listKeysToday = Object.keys(this.jsonDateToday)
        let checkEmit = false
        listKeys.forEach(el => {
            const check = listKeysToday.indexOf(el)
            if (check == -1) {
                checkEmit = true
            }
        })
        if (checkEmit) {
            this._sharedService.emitChange(['activeAlertNewClient', 'client'])
        }
    }

    preSubmit() {
        this.isCheck = false;
        let familyName = this.formNewClient.get('familyName').value;
        let firstName = this.formNewClient.get('firstName').value;
        this.validatorEmail('email1', this.formNewClient.get('email1').value)
        this.validatorEmail('email2', this.formNewClient.get('email2').value)
        if (familyName.trim() === '' || firstName.trim() === '' || this.validEmail1 === true || this.validEmail2 === true) {
            this.isValidate = true;
            this._sharedService.emitChange('valid-profile')
        } else {
            this.isValidate = false;
            this._sharedService.emitChange('unvalid-profile')
        }
        this.isCheck = true
        if (familyName.trim() !== '') {
            this.isFamilyName = false
        } else {
            this.isFamilyName = true
        }
        if (firstName.trim() !== '') {
            this.isFirstName = false
        } else {
            this.isFirstName = true
        } 
        this._sharedService.emitChange(['activeAlertNewClient', 'client'])
    }

    checkAgain() {
        let familyName = this.formNewClient.get('familyName').value;
        let firstName = this.formNewClient.get('firstName').value;
        if (familyName.trim() === '' || firstName.trim() === '' || this.validEmail1 === true || this.validEmail2 === true) {
            this.isValidate = true;
            this._sharedService.emitChange('valid-profile')
        } else {
            this.isValidate = false;
            this._sharedService.emitChange('unvalid-profile')
        }
    }

    submitFormNewClient() {
        if (this.isValidate) {
            onsNotification.confirm({
                message: this.en['alert-validate'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: this.en['alert-cancel'],
                modifier: 'rowfooter',
            })
            return;
        }
        for (let i = 0; i < this.urls.length; i++) {
            let url = this.urls[i]
            this.listUrl.push({ _id: mongoObjectId(), title: url.value.urlName, url: url.value.url })
        }
        let resultListClinic = this.listClinic.find(option => option.action === true)
        let resultListGender = this.arrayGender.find(option => option.action === true)
        let resultListUseTreatment = this.arrayUseTreatment.find(option => option.action === true)
        let resultListAccelation = this.arrayDevice.find(option => option.action === true)
        let resultListAlignerOK = this.arrayAligner.find(option => option.action === true && option.name === 'OK')
        let resultListAlignerNG = this.arrayAligner.find(option => option.action === true && option.name === 'NG')
        let resultListPublicationOK = this.arrayPublication.find(option => option.action === true && option.name === 'OK')
        let resultListPublicationNG = this.arrayPublication.find(option => option.action === true && option.name === 'NG')
        if (resultListClinic) {
            this.clinicSelected = resultListClinic._id
        } else {
            this.clinicSelected = null
        }
        if (resultListGender) {
            this.genderSelected = resultListGender.value
        } else {
            this.genderSelected = null
        }
        if (resultListUseTreatment) {
            this.useTreatmentSelected = resultListUseTreatment.value
        } else {
            this.useTreatmentSelected = null
        }
        if (resultListAccelation) {
            this.accelationSelected = resultListAccelation.value
        } else {
            this.accelationSelected = null
        }
        if (resultListAlignerOK) {
            this.alignerMailSelected = true
        } else if (resultListAlignerNG) {
            this.alignerMailSelected = false
        } else {
            this.alignerMailSelected = null
        }
        if (resultListPublicationOK) {
            this.publicationSelected = true
        } else if (resultListPublicationNG) {
            this.publicationSelected = false
        } else {
            this.publicationSelected = null
        }
        // if (this.formNewClient.get('firstName').valid && this.formNewClient.get('familyName').valid && this.validEmail1 == false && this.validEmail2 == false) {

        const dataSave: any = {
            accelationDevice: this.accelationSelected,
            address1: this.formNewClient.get('address1').value,
            address2: this.formNewClient.get('address2').value,
            case: this.formNewClient.get('case').value,
            clientNumber: this.formNewClient.get('clientNumber').value,
            clinic: this.clinicSelected,
            cordinator: this.cordinatorSelected,
            doctor: this.doctorSelected,
            email1: this.formNewClient.get('email1').value,
            email2: this.formNewClient.get('email2').value,
            enableAlignerMail: this.alignerMailSelected,
            familyName: this.formNewClient.get('familyName').value,
            familyNameKana: this.formNewClient.get('familyNameKana').value,
            firstName: this.formNewClient.get('firstName').value,
            firstNameKana: this.formNewClient.get('firstNameKana').value,
            gender: this.genderSelected,
            useTreatmentMenu: this.useTreatmentSelected,
            phone1: this.formNewClient.get('phoneNumber1').value,
            phone2: this.formNewClient.get('phoneNumber2').value,
            presentationName: this.formNewClient.get('presentationName').value,
            publicationApproved: this.publicationSelected,
            relatedUrls: this.listUrl,
            searchName: this.formNewClient.get('firstName').value + this.formNewClient.get('familyName').value + this.formNewClient.get('firstName').value,
            searchNameKana: this.formNewClient.get('firstNameKana').value + this.formNewClient.get('familyNameKana').value + this.formNewClient.get('firstNameKana').value,
            searchPhone1: this.formNewClient.get('phoneNumber1').value,
            searchPhone2: this.formNewClient.get('phoneNumber2').value,
            birthday: this.timestampBirthday,
            lastDate: this.timestampLast,
            startDate: this.timestampStart,
        }
        const listKeys: any[] = Object.keys(this.jsonChangeDataSave)
        listKeys.forEach(key => {
            dataSave[key] = this.jsonChangeDataSave[key]
        })
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'client',
                    type: 'create',
                    value: dataSave,
                },
            ],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                        this._sharedService.emitChange('setRoutes')
                        this.router.navigate(['/app/main/client/edit/' + success['response'].client.updatedItem])
                    }
                },
            )
        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    mainClient() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator","deleted": {"$ne": true}}': true,
                        '{"roles":"doctor","deleted": {"$ne": true}}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const user = success['user']
                    this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                    const emitSakura = {}
                    emitSakura['enableBehavior'] = this.enableBehavior
                    this.stateServices.emitChangeEnableBehavior(emitSakura)
                    this.listDoctor = success['response']['staff']['paths']['{"roles":"doctor","deleted": {"$ne": true}}']
                    this.listCordinator = success['response']['staff']['paths']['{"roles":"cordinator","deleted": {"$ne": true}}']
                    this.listClinic = success['response']['clinic']['paths']['{}']

                    const option2GeneralAll: any[] = success['response'] ? success['response']['setting']['paths']['{}'] : []
                    this.jsonDataSave = {}
                    if (option2GeneralAll && option2GeneralAll.length > 0) {
                        const arraySettingOption = option2GeneralAll.find(el => {
                            return el['_id'] == 'option'
                        })
                        if (arraySettingOption) {
                            if (this.enableBehavior == 'true') {
                                this.listOption2General = (arraySettingOption['clientProfileFormHeader'] && arraySettingOption['clientProfileFormHeader']) ? arraySettingOption['clientProfileFormHeader']['properties'] : []
                            } else {
                                this.listOption2General = []
                            }
                        } else {
                            this.listOption2General = []
                        }
                        this.jsonChangeDataSave = {}
                        const fakeFooterByHeader: any[] = []
                        this.listOption2General.forEach(el => {
                            const jsonFake = {}
                            fakeFooterByHeader.push(jsonFake)
                            if (el['schema'] && el['schema']['type'] == 'date') {
                                if (el['schema']['uiOptions'] && el['schema']['uiOptions']['behavior'] == 'recentToday') {
                                    this.jsonDateToday[el['propertyName']] = moment().utc().startOf('day').valueOf()
                                }
                            }
                        })
                        let listFooter: any [] = []
                        if (arraySettingOption) {
                            if (this.enableBehavior == 'true') {
                                listFooter = (arraySettingOption['clientProfileFormFooter'] && arraySettingOption['clientProfileFormFooter']['properties']) ? arraySettingOption['clientProfileFormFooter']['properties'] : []
                            } else {
                                listFooter = []
                            }
                        }
                        listFooter.forEach(el => {
                            if (el['schema'] && el['schema']['type'] == 'date') {
                                if (el['schema']['uiOptions'] && el['schema']['uiOptions']['behavior'] == 'recentToday') {
                                    this.jsonDateToday[el['propertyName']] = moment().utc().startOf('day').valueOf()
                                }
                            }
                        })
                        this.listOptionFooter = fakeFooterByHeader.concat(listFooter)
                    }
                },
            )
        })
    }

    checkAction(name, array, canDeactivate = true) {
        this._sharedService.emitChange(['activeAlertNewClient', 'client'])
        array.forEach(function(val) {
            if (val.name !== name) {
                val.action = false
            } else {
                if (val.action && canDeactivate) {
                    val.action = false
                } else {
                    val.action = true
                }
            }
        })
    }

    buttonSendMail(emailNumber) {
        let email = ''
        if (emailNumber === 'email1') {
            email = this.formNewClient.value.email1
        } else if (emailNumber === 'email2') {
            email = this.formNewClient.value.email2
        } else {
            email = 'unknow'
        }
        window.open('mailto:' + email + '?cc=&subject=&body=', '_blank')
    }

    buttonOpenUrl(url) {

        window.open(url)
    }

    alert() {
        if (localStorage.lang === 'true') {
            onsNotification.alert('Please save or descard this item', { title: '<b>Error</b>' })
        } else {
            onsNotification.alert('先にこのアイテムを保存するか破棄してください', { title: '<b>Error</b>' })
        }
    }

    openDoctorModal(option) {
        const arrayNewclient = ['activeModalDoctor', option, this.listDoctor, this.listCordinator]
        this._sharedService.emitChange(arrayNewclient)
    }

    addUrl() {
        this.urls = this.formNewClient.get('urls')['controls']
        this.urls.push(this.createItemUrl())
        this.displayRemoveUrl = false

    }

    removeUrl(index) {

        this.urls.splice(index, 1)
        if (index === 0 && this.urls.length < 1) {
            this.displayRemoveUrl = true
            this.urls.push(this.createItemUrl())
        }

    }

    createItemUrl(): FormGroup {
        return this.formBuilder.group({
            urlName: '',
            url: '',
        })
    }

    sortUrl(index, action: string) {
        if (action === 'up') {
            let br1 = this.urls[index - 1]
            let br2 = this.urls[index]
            this.urls.splice(index - 1, 2, br2, br1)

        } else if (action === 'down') {
            let br1 = this.urls[index]
            let br2 = this.urls[index + 1]
            this.urls.splice(index, 2, br2, br1)

        } else {

        }
    }

    changeDisplayRemoveUrl() {
        this.displayRemoveUrl = false
    }

    validatorEmail(email, emailAddress) {
        const resourceUrl = 'form/checkMx'
        let domain = ''
        if (emailAddress.indexOf('@') !== -1) {
            domain = emailAddress.substr(emailAddress.indexOf('@') + 1, emailAddress.length - 1)
        }
        const resourceData = { host: domain }
        if (email === 'email1') {
            if (!this.formNewClient.get(email).valid && this.formNewClient.get(email).value != '') {
                this.validEmail1 = true
                this.errorTextEmail1 = 'Invalid mail format'
            } else if (this.formNewClient.get(email).valid) {


                this.restApi.http_post(resourceUrl, resourceData).subscribe(
                    res => {
                        this.statusCheck = res
                        if (this.statusCheck.status === 'notfound') {
                            this.validEmail1 = true
                            this.errorTextEmail1 = 'Mail server not exists (string after atmark may be wrong)'
                        } else {
                            this.validEmail1 = false
                        }
                        if (this.isCheck) 
                            this.checkAgain()
                    },
                )
            } else {
                this.validEmail1 = false
            }
        } else if (email === 'email2') {
            if (!this.formNewClient.get('email2').valid && this.formNewClient.get('email2').value != '') {
                this.validEmail2 = true
                this.errorTextEmail2 = 'Invalid mail format'
            } else if (this.formNewClient.get(email).valid) {


                this.restApi.http_post(resourceUrl, resourceData).subscribe(
                    res => {
                        this.statusCheck = res
                        if (this.statusCheck.status === 'notfound') {
                            this.validEmail2 = true
                            this.errorTextEmail2 = 'Mail server not exists (string after atmark may be wrong)'
                        } else {
                            this.validEmail2 = false
                        }
                        if (this.isCheck) 
                            this.checkAgain()
                    },
                )
            } else {
                this.validEmail2 = false
            }
        } else {

        }
    }

    updateDatepicker(event, option) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        if (event && event['_d']) {
            // this._sharedService.emitChange('activeAlertNewClient');
            if (option === 'birthday') {
                const timestamp = moment(event['_d'])
                timestamp.set({ hours: 10 })
                // this.timestampBirthday = moment(event['_d']).utc().startOf('day').valueOf();
                // this.showDateBirthday = moment(this.timestampBirthday).format('YYYY.MM.DD ddd');
                // this.showAge = Math.round((moment().startOf('year').valueOf() - moment(this.timestampBirthday).startOf('year').valueOf()) / 31536000000);
                this.timestampBirthday = moment(timestamp).utc().startOf('day').valueOf()
                this.showDateBirthday = moment(timestamp).format('YYYY.MM.DD ddd')
                this.showAge = moment().startOf('day').diff(moment(this.timestampBirthday).add(addTime, 'hours'), 'years')
                // this.dateBirthday = moment(timestamp);
            } else if (option === 'start') {
                // this.timestampStart = moment(event['_d']).utc().startOf('day').valueOf();
                // this.showDateStart = moment(this.timestampStart).format('YYYY.MM.DD ddd');
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampStart = moment().utc().startOf('day').valueOf()
                    this.showDateStart = moment().format('YYYY.MM.DD ddd')
                    // this.dateStart = moment(moment().valueOf());
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampStart = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateStart = moment(timestamp).format('YYYY.MM.DD ddd')
                    // this.dateStart = moment(moment(timestamp).valueOf());
                }
            } else if (option === 'last') {
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampLast = moment().utc().startOf('day').valueOf()
                    this.showDateLast = moment().format('YYYY.MM.DD ddd')
                    // this.dateLast = moment(moment().valueOf());
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampLast = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateLast = moment(timestamp).format('YYYY.MM.DD ddd')
                    // this.dateLast = moment(moment(timestamp).valueOf());
                }
            }
        }
    }

    nextDate(timestampAdd, day, option) {

        if (option === 'start') {
            if (this.showDateStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'start')
            }
        } else {
            if (this.showDateLast !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'last')
            }
        }
    }

    prevDate(timestampAdd, day, option) {

        if (option === 'start') {
            if (this.showDateStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'start')
            }
        } else {
            if (this.showDateLast !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'last')
            }
        }
    }

    setNoneAcceledent() {
        this.arrayDevice.forEach(function(val) {
            val.action = false
        })
    }

    selectDefaultTreatementUse() {
        // default is Use
        // this.arrayUseTreatment = [...Constants.ARRAY_USE_TREATMENT];
        this.arrayUseTreatment.forEach(function(val, index) {
            val.action = index == 0
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client/new-client/new-client.component.ts